import { TablePagination } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import FormContainer from "../../../../../../common/components/form_container";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { GenerateAtribuicoesGrupoColumns } from "../columns/atribuicoes_grupo";
import { AtribuicaoGrupo } from "../../../../domain/models/atribuicao_grupo";

/**
 * Grupo Acesso Table
 */

type Props = {
  loading: boolean,
  saving: boolean,
  gridRowSelectionModel: GridRowSelectionModel,
  atribuicoesGrupo: AtribuicaoGrupo[],
  page: number,
  rowsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void,
  onRowsPerPageChange: (rowsPerPage: number) => void,
  onSelectionModelChange: (selectionModel: GridRowSelectionModel) => void,
};

export const TabelaAtribuicoesGrupo = ({
  loading,
  gridRowSelectionModel,
  atribuicoesGrupo,
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
  onSelectionModelChange,

}: Props) => {

  const columnsDef = useMemo(() => {
    return GenerateAtribuicoesGrupoColumns();
  }, []);

  return (
    <>
      <CascateList
        title="Atribuições do Grupo de Acesso"
        defaultOpen={true}>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <FormContainer title='Selecione as Atribuições do Grupo' arrangement='fullRow' border={false}>
            <>
              <StyledDataGrid
                tableName="atribuições_grupo"
                getRowHeight={() => 'auto'}
                disableColumnMenu={false}
                getRowId={(row: AtribuicaoGrupo) => row.idAtribuicao}
                checkboxSelection={true}
                rowSelectionModel={gridRowSelectionModel}
                onRowSelectionModelChange={onSelectionModelChange}
                disableRowSelectionExcludeModel={true}
                columns={columnsDef}
                loading={loading}
                rows={atribuicoesGrupo}
                rowCount={atribuicoesGrupo.length}
                pageSizeOptions={[100]}
                paginationMode="server"
                paginationModel={{
                  page: page,
                  pageSize: rowsPerPage,
                }} />

              <TablePagination
                component="div"
                count={totalItems}
                page={page - 1}
                rowsPerPageOptions={[100]}
                onPageChange={(_, p) => onPageChange(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />
            </>

          </FormContainer>

        </div>
      </CascateList>
    </>
  );
}